module.exports = __webpack_public_path__ + "img/second-section-1.3bdf7eeb.jpg";